// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

@supports (min-height: 100dvh) {
  .App {
    min-height: 100dvh;
  }
}

.App>* {
  position: relative;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".App {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  position: relative;\r\n}\r\n\r\n@supports (min-height: 100dvh) {\r\n  .App {\r\n    min-height: 100dvh;\r\n  }\r\n}\r\n\r\n.App>* {\r\n  position: relative;\r\n  z-index: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
